import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/Widget/label";
import PropTypes from "prop-types";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import { resolver } from "lib/dataentry/lib/dataentryform/formitems/resolver";
import StringLabel from "lib/common/descriptorcontrols/StringField/label";

export class Widgetlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        const config = descriptor.config;
        const enabled = !descriptor.boundTo || activeRecord.isFieldEnabled(descriptor.boundTo);
        if (config) {
            if (config.itemInfo) {
                // use a full form item
                const Label = resolver(config.itemInfo);
                const newDesc = {
                    ...descriptor,
                    ...config.itemInfo,
                };
                return <Label
                    {...this.props}
                    descriptor={newDesc}
                />;
            }
            if (config.script) {
                // just a control here...
                let value;
                try {
                    /* eslint-disable-next-line no-new-func */
                    value = Function("instance", config.script)(activeRecord);
                } catch (e) {
                    console.warn(`Error executing widget label script ${config.script}`, e);
                    value = "" + e;
                }
                return <StringLabel
                    {...this.getPlumbingProps()}
                    descriptor={{
                        ...descriptor,
                        key: descriptor.label.toLowerCase().replace(/[^a-z0-9_]/g, "-"),
                    }}
                    controlOnly={false}
                    value={value}
                    enabled={enabled}
                />;
            }
        }
        return <Control
            {...this.getPlumbingProps()}
            enabled={enabled}
        />;
    }

}

Widgetlabel.propTypes = {
    ...Widgetlabel.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes(null, false)),
};

export default Widgetlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Widget/label.js